import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { AdvancedCommerceSearchResolver } from '@df/module-advanced-commerce';
import { SearchResolver } from '@df/search/search.resolver';
import { AdvancedCommerceConfigStore } from '@df/module-advanced-commerce/store/advanced-commerce-config.store';

export const dynamicSearchResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(AdvancedCommerceConfigStore).config()?.enabled
        ? inject(AdvancedCommerceSearchResolver)?.resolve(route, state)
        : inject(SearchResolver)?.resolve(route, state);
};
